import React, { Component } from 'react';
import { compose } from 'recompose';
import { Link } from 'react-router';
import config from '../../config';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { HTMLTrans } from '../Common/Translations';
import { isMuslimProStore, willHideOnMuslimPro } from '../Common/Store/Store';
import { withLandingPageData } from './Data';

const Cell = (props) => {
  const {
    img = `${config.s3BucketUrl}/media/wysiwyg/pages/home/photobook.png`,
    caption = {},
    url = '',
    t,
    tRoute
  } = props;
  return (
    <div className='text-center col-lg-4 mb-5'>
      <Link to={tRoute(url)}>
        <img className="img-fluid lazyload" data-src={img} alt={t(caption.id, caption.defaultMsg)}/>
        <div className='ProximaNova-Bold text-uppercase mt-3'>{t(caption.id, caption.defaultMsg)}</div>
      </Link>
    </div>
  );
};

const ViewMoreProductsButton = ({ url }) => (
  <div className='text-center'>
    <a href={url} className="btn btn-primary" role="button">
      <HTMLTrans id="landing_page.whatyoucancreate_button">VIEW MORE PRODUCTS</HTMLTrans>
    </a>
  </div>
);

const ViewMoreProductsButtonWillHideOnMuslimPro = willHideOnMuslimPro(ViewMoreProductsButton);

const Presentation = (props) => {
  const {
    cells = [],
    store = {},
    tRoute,
  } = props;
  const name = store.name || 'Photobook';

  return (
    <div>
      {isMuslimProStore({ code: config.storeCode }) &&
      <div className='container'>
        <h1 className='text-center mb-2 landing-h2'><HTMLTrans
          id="landing_page.whatyoucancreate_title" variables={{ 'name': name }}>{name} Best
          Sellers</HTMLTrans></h1>
        <h2 className='text-center text-gray-lighten-1 mb-5 landing-h4'>
          <HTMLTrans id="landing_page.whatyoucancreate_description">Create personalised photo gifts
            for your happy, smile-worthy moments</HTMLTrans>
        </h2>
        <div className='row'>
          {cells.map(item => (<Cell key={item.caption.id} {...item} {...props}/>))}
        </div>
        <ViewMoreProductsButtonWillHideOnMuslimPro url={tRoute('/product')} store={store}/>
      </div>
      }
    </div>
  );
};

const enhance = compose(
  withStoreDetail,
  withLandingPageData,
);

export default enhance(Presentation);
export const undecorated = Presentation;



// WEBPACK FOOTER //
// ./src/LandingPage/WhatYouCanCreate.js